import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const errorPageErrorSelector = (state: AppState) => state.errorPage.error;
export const useErrorPageErrorSelector = () => useSelector(errorPageErrorSelector);
